<template>
    <BaseWidget :title="widget.title">
        <div>
            <AppButton :href="route('rollcall.select')" v-if="widget.content.uses_attendance">
                {{ $t('messages.rollcall') }}
            </AppButton>

            <div class="inline-block inline-flex" v-if="widget.content.enabled">
                <div class="pl-3 leading-7 font-medium text-gray-500">
                    <InertiaLink :href="widget.content.group_url" class="text-indigo-500">
                        {{ widget.content.group_name }}
                    </InertiaLink>
                </div>

                <template v-for="turn in widget.content.turns" :key="turn.attendance_edit_link">
                    <AppButton
                        element="InertiaLink"
                        :href="turn.attendance_edit_link"
                        class="ml-3"
                        size="sm"
                        v-if="turn.attendance_edit_link"
                    >
                        {{ turn.text }}
                    </AppButton>
                    <AppButton
                        element="InertiaLink"
                        :href="turn.attendance_create_link"
                        class="ml-3"
                        size="sm"
                        desired-action
                        v-else
                    >
                        {{ turn.text }}
                    </AppButton>
                </template>

                <a
                    :href="widget.content.missing_attendances"
                    :title="$t('messages.attendance_missing')"
                    v-if="widget.content.missing_attendances"
                >
                    <div class="flex">
                        <IconBellFilled class="animate-ping absolute w-6 h-6 text-indigo-500 mx-2.5 opacity-75" />
                        <IconBellFilled class="relative inline-flex w-6 h-6 text-indigo-600 mx-2.5" />
                    </div>
                </a>
            </div>
        </div>
        <div class="flex flex-wrap gap-2 items-center mt-3">
            <AppButton
                element="InertiaLink"
                :href="group.url"
                v-for="group in widget.content.otherGroups"
                :key="group.id"
                size="sm"
            >
                {{ group.text }}
            </AppButton>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import AppButton from '@/components/AppButton.vue';
import { IconBellFilled } from '@tabler/icons-vue';

export default {
    name: 'QuickOptionsWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        BaseWidget,
        AppButton,
        IconBellFilled,
    },
};
</script>
